// extracted by mini-css-extract-plugin
export default {"box":"TitlePicture_box__Qkfdy","header":"TitlePicture_header__ZeqXf","img":"TitlePicture_img__JLaiv"};